import { Component, OnInit, ViewChild, Input, OnDestroy, TemplateRef, Output, EventEmitter } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import {  Tarea, SeriePredeterminada, SubSeriePredeterminada, Static, BaseControl } from '@app/shared';
import { Subject } from 'rxjs';
import { ManageRestrictionDocumentDataService } from './shared/manage-restriction-document.data.service';
import { ManageRestrictionDocumentConfig } from './shared/manage-restriction-document.config';
import { RestrictionDocumentFormService } from './shared/manage-restriction-document.form.service';
import { FormGroup } from '@angular/forms';
import { find } from 'lodash';
import { ToastrService } from 'ngx-toastr';

interface restrictionDocument {
  serie: number;
  subserie?: number;
  };

@Component({
  selector: 'iw-manage-restriction-document',
  templateUrl: './manage-restriction-document.component.html',
  styleUrls: ['./manage-restriction-document.component.scss'],
  providers: [ ManageRestrictionDocumentDataService, RestrictionDocumentFormService ]
})


export class ManageRestrictionDocumentComponent implements OnInit, OnDestroy {
  @Input() sourceTask: Tarea;

  // Configuracion de la tabla
  settings = {};
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // listado de las series
  series: SeriePredeterminada[] = [];
  // listado de las subseries
  subseries: SubSeriePredeterminada[] = [];
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Referencia del formulario
  form: FormGroup = null;
  // Controla la visualizacion del formulario o la tabla de restricciones de documento
  formOpen: boolean = false;
  // Entrada de las series internas
  Internalseries: SeriePredeterminada[] = [];
  // Lista de subseries a mostrar
  subseriesList: any[] = [];
   // id de la subserie seleccionada
   idSubSerieSelect: any;
   // listado de restricciones actuales 
  listRestriction: restrictionDocument[] = [];
  private Internalsubseries: SubSeriePredeterminada[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a ala plantilla para el control de selector
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia al control de series
  @ViewChild("serieControl") serieControl: TemplateRef<any>;
  // Referencia al control de subseries
  @ViewChild("subserieControl") subserieControl: TemplateRef<any>;
  // Contiene si la forma tiene obligacion
  @Output() listRestrictDoc: EventEmitter<restrictionDocument[]> = new EventEmitter();

  constructor(
    private mdds: ManageRestrictionDocumentDataService,
    private dcrfs: RestrictionDocumentFormService,
    private toastr: ToastrService,
    ) { }

  async ngOnInit() {
    const docsC = new ManageRestrictionDocumentConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.actionTable(data);
    });
    this.series = await this.mdds.getSeriesDocumentary();
    this.subseries = await this.mdds.getSubseriesDocumentary();
    if (this.series && this.subseries){
      this.Internalseries = await this.processOptions(this.series);
      this.Internalsubseries = await this.processOptions(this.subseries);
      if (this.sourceTask && this.sourceTask.tarea_forma[0].parametros && this.sourceTask.tarea_forma[0].parametros.hasOwnProperty("asociar")) {
        if(this.sourceTask.tarea_forma[0].parametros.hasOwnProperty("restrictiton_documents")){
          this.listRestriction = this.sourceTask.tarea_forma[0].parametros["restrictiton_documents"];
          this.loadingDocuments(this.Internalseries,this.Internalsubseries);
        }
      }
    } 
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga los documentos y setea la informacion
   *
   * @memberof ManageRestrictionDocumentComponent
   */
  loadingDocuments(series:any, subseries:any) {
    let newList: any[] = [];
    this.listRestriction.forEach(async function (res, i) {
        let row = {id: i};
        let serieObj:any = find(series,{id: res.serie});
        let subserieObj:any = find(subseries,{id: res.subserie});
        if(serieObj){
          row['serie'] = serieObj.id;
          row['serie_nombre'] = serieObj.nombre;
        }
        if(subserieObj){
          row['subserie'] = subserieObj.id;
          row['subserie_nombre'] = subserieObj.nombre;
        }
        newList.push(row);
      });
    this.sourceData = new LocalDataSource(newList);
    this.sourceData.refresh();
  }

  /**
   * Controla las acciones de la tabla
   *
   * @param {*} data
   * @memberof ManageRestrictionDocumentComponent
   */
  async actionTable(data: any) {
    switch (data.action) {
        case 'agregar':
            this.formOpen = true;
            this.actionForm = 'Agregar';
            this.controls = this.dcrfs.getFieldsRestrictionDocument({
                'select':this.ngSelectTpl,
                'serie':this.serieControl,
                'subserie':this.subserieControl},null);
            break;
        case 'delete':
          for (let index = 0; index < this.listRestriction.length; index++) {
            if (this.listRestriction[index].serie == data.data.serie && this.listRestriction[index].subserie == data.data.subserie) {
              this.listRestriction.splice(index, 1);
            }
          }
          this.listRestrictDoc.emit(this.listRestriction);
          this.loadingDocuments(this.Internalseries, this.Internalsubseries);
          break;
    }
  }

  /**
   * Guarda las funciones agregadas al documento asociado correspondiente
   *
   * @param {any} data
   * @memberof ManageRestrictionDocumentComponent
   */
   sended(data: any) {
    if(data){
      let serieObj:any = find(this.Internalseries,{id: data.serie});
      let subserieObj:any = find(this.Internalsubseries,{id: data.subserie});
      let checkData = null;
      if(data.serie && data.subserie){
        checkData = find(this.listRestriction,{serie:data.serie,subserie:data.subserie});
      }else{
        checkData = find(this.listRestriction,{serie:data.serie});
      }
      if(checkData){
        this.toastr.warning("La estructura ya se encuentra registrada","Error");
      }else{
        let row:any = {};
      if(serieObj){
        row['serie'] = serieObj.id;
        row['serie_nombre'] = serieObj.nombre;
      }
      if(subserieObj){
        row['subserie'] = subserieObj.id;
        row['subserie_nombre'] = subserieObj.nombre;
      }
      if(row){
        this.listRestriction.push(row);
        this.sourceTask.tarea_forma[0].parametros["restrictiton_documents"] = this.listRestriction;
        this.sourceData = new LocalDataSource(this.listRestriction);
        this.sourceData.refresh();
        this.listRestrictDoc.emit(this.listRestriction);
        this.closeFormRestrictionDocument();
      }
      } 
    }
  }

  /**
   * Cierra el formulario
   *
   * @returns
   * @memberof ManageRestrictionDocumentComponent
   */
  closeFormRestrictionDocument(){
    this.formOpen = false;
  }

 /**
   * mapea el valor de los selectores para retornar los nombre con el codigo
   *
   * @param {data<any>} data
   * @returns {data<any>[]}
   * @memberof ManageRestrictionDocumentComponent
   */
  async processOptions(data:any){
    let new_data:any = [];
    data.forEach((element: any) => {
      let temporal_element:any = Static.copyObjet(element);
      temporal_element.nombre = element.codigo + " - " + element.nombre; 
      new_data.push(temporal_element)
    });
    return new_data
  }

  /**
   *Obtiene los cambios en los selectores de serie, subserie y tipo documental
   *
   * @param {*} data
   * @param {string} type
   * @memberof DocumentAssessmentComponent
   */
   changeForm(data: any, type: string) {
    if(type=="serie" && data !== undefined){
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.Internalsubseries.forEach(subseries =>{
        if(subseries.serie.id == data.id){
          this.subseriesList = [...this.subseriesList, subseries];
        }
      });
      this.idSubSerieSelect = null;
    }else if(type=="serie" && data == undefined) {
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.idSubSerieSelect = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-restriction-document/manage-restriction-document.component.ts